import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private cookieService: CookieService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
  ): boolean {
    const token = this.cookieService.get("access_token");
    // Get the route path from the ActivatedRouteSnapshot
    const routePath = route.routeConfig.path || '' ;
    console.log("patha::", routePath)
    const isLoginPage = routePath === 'login';
     console.log("isLoginPage::", isLoginPage)
    if (isLoginPage) {
      // If trying to access login page and already logged in
      if (token) {
        this.router.navigate(["/dashboard"])
        return false
      }
      // Allow access to login page if not logged in
      return true;
    } else {
      // For all other routes (dashboard, etc.)
      if (!token) {
        this.router.navigate(["/login"]);
        return false;
      }
      // Allow access if token exists
      return true;
    }
  }
  //   if(!token) {
  //     this.router.navigate(["/login"]);
  //     return false;
  //   } else {
  //   return true;
  // }
  //}
}
